module.exports = "<p class=\"nav-item-text\" ng-hide=\"sourcesCtrl.detail.editMode\" ng-bind=\"sourcesCtrl.selectedSource.text\"></p>\n<div class=\"field field-block\" ng-class=\"sourcesCtrl.detail.error.text.error ? 'field-error' : ''\">\n  <textarea ng-show=\"sourcesCtrl.detail.editMode\" type=\"text\" class=\"form-control\" id=\"text\" placeholder=\"Enter Note\" ng-model=\"sourcesCtrl.selectedSource.text\"></textarea>\n  <label for=\"text\" ng-if=\"sourcesCtrl.detail.error.text.error\" ng-bind=\"sourcesCtrl.detail.error.text.error\"></label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./project/modals/sources/partials/detail.note.html
// module id = 864
// module chunks = 3